import { render, staticRenderFns } from "./OilReport.vue?vue&type=template&id=5632cede&scoped=true&"
import script from "./OilReport.vue?vue&type=script&lang=js&"
export * from "./OilReport.vue?vue&type=script&lang=js&"
import style0 from "./OilReport.vue?vue&type=style&index=0&id=5632cede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632cede",
  null
  
)

export default component.exports